<ng-container *transloco="let t">
  <div class="flex h-full flex-col items-center justify-center gap-6">
    <div class="space-y-2 text-center">
      <h1 class="text-4xl font-bold md:text-5xl">
        {{ t('register-user-form-title') }}
      </h1>
      <p class="hidden sm:block">
        {{ t('register-user-form-subtitle') }}
      </p>
    </div>
    <div class="card bg-base-100 w-full max-w-lg shadow-2xl">
      <div class="card-body">
        @if (isLoading()) {
          <core-loading-spinner />
        } @else {
          @if (!submitted()) {
            <form [formGroup]="userForm">
              <fieldset class="fieldset gap-4">
                <div class="space-y-1">
                  <label
                    class="input floating-label w-full"
                    [ngClass]="{
                      'input-error':
                        userFormFirstName?.invalid &&
                        userFormFirstName?.touched,
                    }"
                  >
                    <span>
                      {{ t('register-user-form-first-name') }}
                    </span>
                    <svg
                      class="h-[1em] opacity-50"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                    >
                      <g
                        stroke-linejoin="round"
                        stroke-linecap="round"
                        stroke-width="2.5"
                        fill="none"
                        stroke="currentColor"
                      >
                        <path
                          d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"
                        ></path>
                        <circle cx="12" cy="7" r="4"></circle>
                      </g>
                    </svg>
                    <input
                      [attr.aria-invalid]="
                        userFormFirstName?.invalid && userFormFirstName?.touched
                          ? true
                          : null
                      "
                      [required]="true"
                      class="w-full placeholder:opacity-50 focus:placeholder-transparent"
                      formControlName="userFormFirstName"
                      [placeholder]="t('register-user-form-first-name')"
                      type="text"
                    />
                  </label>
                  @if (
                    userFormFirstName?.invalid && userFormFirstName?.touched
                  ) {
                    @if (
                      userFormFirstName?.errors?.['minlength'] ||
                      userFormFirstName?.errors?.['maxlength']
                    ) {
                      <p class="label-text-alt text-error">
                        {{
                          t(
                            'register-user-form-error-first-name-minMaxLength',
                            {
                              minLength: 2,
                              maxLength: 64,
                            }
                          )
                        }}
                      </p>
                    }
                  }
                </div>
                <div class="space-y-1">
                  <label
                    class="floating-label input w-full"
                    [ngClass]="{
                      'input-error':
                        userFormLastName?.invalid && userFormLastName?.touched,
                    }"
                  >
                    <span>
                      {{ t('register-user-form-last-name') }}
                    </span>
                    <svg
                      class="h-[1em] opacity-50"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                    >
                      <g
                        stroke-linejoin="round"
                        stroke-linecap="round"
                        stroke-width="2.5"
                        fill="none"
                        stroke="currentColor"
                      >
                        <path
                          d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"
                        ></path>
                        <circle cx="12" cy="7" r="4"></circle>
                      </g>
                    </svg>
                    <input
                      class="w-full placeholder:opacity-50 focus:placeholder-transparent"
                      formControlName="userFormLastName"
                      [placeholder]="t('register-user-form-last-name')"
                      type="text"
                    />
                  </label>
                  @if (userFormLastName?.invalid && userFormLastName?.touched) {
                    @if (
                      userFormLastName?.errors?.['minlength'] ||
                      userFormLastName?.errors?.['maxlength']
                    ) {
                      <p class="label-text-alt text-error">
                        {{
                          t('register-user-form-error-last-name-minMaxLength', {
                            minLength: 2,
                            maxLength: 64,
                          })
                        }}
                      </p>
                    }
                  }
                </div>
                <div class="space-y-1">
                  <label
                    class="floating-label input w-full"
                    [ngClass]="{
                      'input-error':
                        userFormCompanyName?.invalid &&
                        userFormCompanyName?.touched,
                    }"
                  >
                    <span>
                      {{ t('register-user-form-company-name') }}
                    </span>
                    <svg
                      class="h-[1em] opacity-50"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="-2 0 16 16"
                      fill="none"
                      stroke="currentColor"
                    >
                      <g stroke-width="0.7">
                        <path
                          d="M323.5-192h-9a1.5,1.5,0,0,0-1.5,1.5V-176h12v-14.5A1.5,1.5,0,0,0,323.5-192ZM318-177v-3h2v3Zm6,0h-3v-3.5a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5v3.5h-3v-13.5a.5.5,0,0,1,.5-.5h9a.5.5,0,0,1,.5.5Zm-8-12h2v2h-2Zm4,0h2v2h-2Zm-4,4h2v2h-2Zm4,0h2v2h-2Z"
                          transform="translate(-313 192)"
                        ></path>
                      </g>
                    </svg>
                    <input
                      [attr.aria-invalid]="
                        userFormCompanyName?.invalid &&
                        userFormCompanyName?.touched
                          ? true
                          : null
                      "
                      [required]="true"
                      class="w-full placeholder:opacity-50 focus:placeholder-transparent"
                      formControlName="userFormCompanyName"
                      [placeholder]="t('register-user-form-company-name')"
                      type="text"
                    />
                  </label>
                </div>
                <div class="space-y-1">
                  <label class="floating-label input w-full">
                    <span>
                      {{ t('register-user-form-business-unit') }}
                    </span>
                    <svg
                      class="h-[1em] opacity-50"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                    >
                      <g
                        stroke-width="2.3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <rect x="4" y="4" width="16" height="16" rx="1"></rect>
                        <path d="M4 12L20 12"></path>
                        <path d="M8 8H10"></path>
                        <path d="M8 16H10"></path>
                      </g>
                    </svg>
                    <input
                      class="w-full placeholder:opacity-50 focus:placeholder-transparent"
                      formControlName="userFormBusinessUnit"
                      [placeholder]="t('register-user-form-business-unit')"
                      type="text"
                    />
                  </label>
                </div>
                <div class="space-y-1">
                  <label
                    class="input floating-label w-full"
                    for="register-user-country-dropdown"
                  >
                    <span>
                      {{ t('register-user-form-country') }}
                    </span>
                    <svg
                      class="h-[1em] opacity-90"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 64 64"
                      fill="none"
                      stroke="currentColor"
                    >
                      <g>
                        <g>
                          <path
                            d="M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M27.819,6.415l0.176-0.205 c0.446-0.515,0.951-1.098,1.027-2.1c0.066-0.833-0.228-1.421-0.546-1.897C29.633,2.077,30.807,2,32,2 c1.465,0,2.903,0.11,4.312,0.313c0.262,0.327,0.606,0.668,1.164,0.897c0.592,0.255,1.291,0.457,2.171,0.249 c0.26-0.062,0.462-0.172,0.636-0.292c0.618,0.177,1.229,0.369,1.831,0.584c0.211,0.609,0.616,1.335,1.604,1.46 c0.556,0.079,1.021-0.008,1.428-0.183c8.475,4.139,14.702,12.153,16.39,21.734c-0.164,0.346-0.188,0.686-0.193,0.901 c-0.002,0.06,0.003,0.121,0.008,0.137c-0.036,0.056-0.082,0.085-0.305,0.192c-0.255,0.123-0.603,0.291-0.924,0.629 c-0.365,0.377-0.533,0.75-0.668,1.05c-0.105,0.234-0.165,0.361-0.274,0.47c-0.07,0.068-0.206,0.109-0.42,0.171 c-0.418,0.12-1.049,0.301-1.473,0.988c-0.403,0.649-0.369,1.249-0.345,1.687c0.003,0.05,0.007,0.101,0.009,0.153 c-0.077,0.038-0.171,0.077-0.269,0.109c0.058-0.316,0.066-0.753-0.217-1.202c-0.382-0.583-0.887-0.671-1.153-0.671 c-0.508,0-0.891,0.292-1.137,0.531c0.005-0.484-0.006-0.93-0.085-1.264c-0.074-0.336-0.027-0.523,0.131-1.065l0.055-0.19 c0.071-0.258,0.212-0.442,0.406-0.698c0.267-0.35,0.599-0.785,0.757-1.457c0.177-0.732,0.125-1.272,0.074-1.795 c-0.019-0.185-0.038-0.38-0.047-0.605l-0.019-0.529c-0.02-0.622-0.036-1.159-0.189-1.943l-0.069-0.349 c-0.154-0.787-0.288-1.466-0.85-2.323c-0.481-0.719-0.861-1.224-1.704-1.672c-0.199-0.109-0.406-0.197-0.617-0.263 c-0.341-0.114-0.653-0.153-0.955-0.192l-0.312-0.042c-0.533-0.078-1.013,0.015-1.366,0.087c-0.286,0.058-0.468,0.105-0.611,0.026 c-0.143-0.078-0.211-0.16-0.388-0.384c-0.094-0.119-0.193-0.244-0.324-0.389c-0.132-0.142-0.222-0.274-0.309-0.399 c-0.172-0.245-0.385-0.551-0.76-0.854c-0.4-0.325-0.705-0.553-1.279-0.754c-1.021-0.338-1.96-0.086-2.77,0.201 c-0.664,0.23-1.069,0.564-1.428,0.858c-0.157,0.13-0.323,0.268-0.484,0.376c-0.158,0.092-0.3,0.156-0.434,0.22 c-0.316,0.147-0.675,0.315-1.072,0.668c-0.276,0.242-1.213,0.853-1.43,0.908c-0.097-0.004-0.193-0.043-0.368-0.118 c-0.226-0.098-0.534-0.229-0.89-0.258l-0.217-0.013c-0.067,0-0.136,0.004-0.187,0.009c-0.454,0.034-0.773,0.182-1.008,0.289 c-0.092,0.042-0.186,0.09-0.304,0.119c-0.346,0.086-0.736,0.08-1.128,0.059c-0.627-0.032-1.242-0.014-1.806,0.146 c-0.463,0.131-0.798,0.357-1.042,0.523c-0.263,0.178-0.326,0.209-0.426,0.21c-0.101,0-0.173-0.042-0.452-0.262 c-0.276-0.218-0.655-0.517-1.214-0.672c-0.403-0.108-0.69-0.143-0.994-0.18l-0.277-0.034c-0.525-0.076-0.9-0.107-1.325-0.142 c-0.197-0.016-0.405-0.032-0.648-0.056l-0.282-0.005l-0.046,0.018c-0.033,0.002-0.072,0.004-0.115,0.006l-0.011-0.007 c-0.32-0.223-0.651-0.452-1.137-0.688c-0.358-0.176-0.649-0.31-0.969-0.425c-0.014-0.357-0.054-0.833-0.161-1.153 c-0.023-0.073-0.047-0.137-0.078-0.217c0.011-0.046,0.031-0.123,0.07-0.24c0.13-0.376,0.332-0.658,0.42-0.771 c0.054-0.037,0.104-0.069,0.152-0.101c0.187-0.12,0.418-0.27,0.656-0.528c0.667-0.706,0.97-1.387,1.046-2.357 c0.06-0.866-0.423-1.448-0.743-1.834C24.52,9.293,24.378,9.122,24.358,9.1c0.043-0.169,0.118-0.242,0.536-0.519 c0.228-0.151,0.466-0.312,0.693-0.511c0.258-0.223,0.506-0.364,0.792-0.527C26.827,7.288,27.334,6.999,27.819,6.415z M4.406,43.785 c-1.138-2.661-1.9-5.521-2.225-8.511c0.245-0.46,0.542-0.906,0.946-1.398c0.289-0.345,0.596-0.554,0.95-0.795 c0.431-0.294,0.92-0.628,1.383-1.207c0.556-0.677,0.738-1.399,0.885-1.98c0.158-0.623,0.248-0.933,0.578-1.162 c0.46-0.314,0.824-0.348,1.484-0.41c0.237-0.021,0.488-0.046,0.765-0.085l0.368-0.054c1.298-0.191,2.127-0.277,3.206,0.027 c0.732,0.205,1.183,0.547,1.754,0.979c0.376,0.285,0.802,0.607,1.346,0.918c0.422,0.241,0.779,0.507,1.124,0.764 c0.771,0.573,1.568,1.165,2.893,1.359c0.76,0.105,1.4-0.13,1.885-0.313c0.243-0.093,0.473-0.18,0.616-0.18 c0.033,0,0.075,0.003,0.143,0.04c0.655,0.364,0.801,0.666,0.828,0.873c-0.14,0.039-0.343,0.074-0.492,0.101 c-0.703,0.123-2.011,0.352-2.162,1.699c-0.076,0.65,0.147,1.057,0.35,1.283c0.524,0.591,1.501,0.528,2.602,0.28 c0.474-0.107,0.965-0.219,1.358-0.219c0.179,0,0.285,0.024,0.333,0.041c0.29,0.105,0.603,0.182,0.908,0.254 c0.134,0.031,0.313,0.073,0.467,0.115c-0.113,0.021-0.229,0.042-0.327,0.059c-0.461,0.079-0.982,0.169-1.459,0.396 c-0.376,0.175-0.697,0.341-0.998,0.498c-0.614,0.318-1.1,0.57-1.84,0.771c-0.226,0.06-0.569,0.009-0.93-0.052 c-0.286-0.049-0.581-0.099-0.893-0.099c-0.738,0-1.319,0.293-1.723,0.865c-0.924,1.292-0.376,2.643-0.112,3.294 c0.359,0.883,1.205,1.936,3.187,1.936c0.933,0,2.012-0.227,3.395-0.713c0.954-0.338,1.513-0.949,1.961-1.441 c0.362-0.398,0.648-0.712,1.11-0.918l0.509-0.232c1.048-0.483,1.815-0.827,2.639-0.439c0.221,0.104,0.317,0.302,0.518,0.798 c0.233,0.578,0.553,1.37,1.444,1.844c0.811,0.43,1.824,0.274,2.564,0.062c0.444-0.127,0.8-0.236,1.058-0.085 c0.271,0.161,0.383,0.379,0.589,0.817c0.184,0.391,0.412,0.877,0.853,1.339c0.132,0.139,0.256,0.274,0.375,0.404 c0.731,0.801,1.423,1.557,2.792,1.881c0.197,0.046,0.398,0.069,0.598,0.069c0.7,0,1.263-0.279,1.715-0.504 c0.388-0.192,0.687-0.336,0.931-0.26c1.021,0.334,1.233,0.563,1.329,0.971c0.084,0.327-0.262,0.602-1.544,1.221 c-0.204,0.099-0.407,0.197-0.6,0.297c-0.689,0.355-1.205,0.399-1.986,0.466c-0.312,0.026-0.645,0.055-1.004,0.104 c-0.725,0.091-1.38,0.248-2.014,0.4c-0.731,0.176-1.422,0.341-2.023,0.341s-1.081-0.165-1.545-0.529 c-0.38-0.304-0.556-0.627-0.8-1.073c-0.177-0.324-0.377-0.691-0.693-1.109c-0.279-0.352-0.519-0.858-0.751-1.349 c-0.512-1.083-1.149-2.431-2.598-2.431c-0.247,0-0.504,0.044-0.764,0.132c-1.126,0.379-1.501,1.281-1.775,1.939 c-0.118,0.283-0.229,0.55-0.379,0.77c-0.375,0.535-0.564,1.103-0.732,1.604c-0.281,0.841-0.369,0.94-0.593,0.973 c-0.361,0.052-0.588-0.101-1.125-0.489c-0.16-0.116-0.326-0.237-0.502-0.353c-0.346-0.23-0.55-0.485-0.809-0.809 c-0.289-0.361-0.617-0.771-1.154-1.157c-0.597-0.44-1.136-0.651-1.611-0.838c-0.384-0.15-0.716-0.28-1.082-0.523 c-0.139-0.093-0.262-0.249-0.405-0.431c-0.325-0.412-0.816-1.035-1.786-1.07l-0.101-0.002c-0.731,0-1.752,0.26-2.466,1.497 c-0.259,0.448-0.44,1.053-0.634,1.693c-0.314,1.045-0.745,2.474-1.42,2.474h-0.001c-0.698-0.047-2.753-1.846-3.741-2.711 c-0.708-0.62-1.32-1.155-1.761-1.447l-0.332-0.229C6.498,44.301,5.72,43.76,4.692,43.76C4.598,43.76,4.502,43.775,4.406,43.785z M32,62c-11.484,0-21.458-6.456-26.499-15.936c0.192,0.117,0.393,0.252,0.608,0.401l0.362,0.249 c0.336,0.223,0.928,0.74,1.555,1.289c2.08,1.82,3.65,3.115,4.929,3.202c2.26,0.149,2.986-2.301,3.466-3.893 c0.151-0.503,0.309-1.023,0.451-1.271c0.265-0.458,0.518-0.496,0.772-0.497c0.056,0.03,0.189,0.2,0.277,0.312 c0.206,0.262,0.464,0.588,0.867,0.857c0.547,0.363,1.032,0.553,1.462,0.721c0.412,0.161,0.768,0.301,1.162,0.593 c0.325,0.232,0.531,0.491,0.771,0.79c0.309,0.385,0.657,0.82,1.265,1.226c0.154,0.102,0.296,0.205,0.434,0.304 c0.648,0.472,1.395,1.017,2.58,0.852c1.505-0.216,1.928-1.481,2.208-2.318c0.137-0.408,0.266-0.793,0.481-1.102 c0.272-0.398,0.436-0.791,0.579-1.137c0.257-0.616,0.342-0.737,0.568-0.813c0.07-0.024,0.108-0.031,0.134-0.027 c0.203,0.064,0.579,0.859,0.781,1.286c0.267,0.565,0.57,1.205,0.978,1.719c0.213,0.281,0.361,0.554,0.52,0.842 c0.286,0.525,0.611,1.121,1.312,1.683c0.827,0.647,1.738,0.962,2.788,0.962c0.838,0,1.641-0.192,2.489-0.396 c0.581-0.14,1.183-0.284,1.808-0.362c0.332-0.045,0.632-0.07,0.913-0.095c0.87-0.073,1.691-0.144,2.735-0.682 c0.178-0.092,0.364-0.182,0.552-0.272c1.245-0.602,3.127-1.511,2.616-3.499c-0.388-1.654-1.859-2.136-2.657-2.396 c-0.252-0.08-0.511-0.121-0.77-0.121c-0.673,0-1.223,0.273-1.665,0.493c-0.384,0.191-0.705,0.338-0.966,0.279 c-0.766-0.182-1.145-0.597-1.772-1.283c-0.127-0.14-0.26-0.283-0.402-0.434c-0.218-0.229-0.345-0.499-0.492-0.812 c-0.252-0.536-0.565-1.203-1.377-1.686c-0.816-0.485-1.87-0.337-2.635-0.116c-0.441,0.127-0.797,0.239-1.069,0.093 c-0.228-0.12-0.331-0.332-0.529-0.825c-0.24-0.595-0.568-1.41-1.52-1.859c-0.528-0.248-1.053-0.369-1.603-0.369 c-0.99,0-1.834,0.39-2.728,0.803l-0.483,0.221c-0.845,0.376-1.36,0.942-1.775,1.397c-0.388,0.426-0.668,0.733-1.147,0.902 c-1.146,0.403-2.039,0.6-2.729,0.6c-0.928,0-1.195-0.35-1.334-0.689c-0.338-0.833-0.306-1.108-0.018-1.405 c0.175,0,0.362,0.037,0.557,0.07c0.522,0.088,1.2,0.164,1.782,0.013c0.954-0.258,1.581-0.584,2.245-0.929 c0.278-0.145,0.573-0.298,0.927-0.463c0.235-0.111,0.598-0.174,0.947-0.234c0.777-0.134,2.396-0.411,2.278-2.084 c-0.121-1.496-1.484-1.816-2.299-2.008c-0.229-0.054-0.464-0.106-0.689-0.188c-0.284-0.101-0.594-0.153-0.944-0.159 c0.146-0.216,0.247-0.484,0.275-0.82c0.085-1.224-0.538-2.215-1.855-2.946c-0.35-0.193-0.724-0.291-1.111-0.291 c-0.512,0-0.945,0.165-1.327,0.311c-0.344,0.13-0.644,0.238-0.889,0.203c-0.82-0.12-1.309-0.483-1.984-0.985 c-0.374-0.278-0.799-0.594-1.325-0.896c-0.433-0.246-0.771-0.503-1.13-0.774c-0.651-0.493-1.324-1.004-2.42-1.312 c-1.395-0.392-2.583-0.296-4.041-0.08l-0.359,0.053c-0.238,0.034-0.458,0.054-0.666,0.073c-0.757,0.071-1.539,0.144-2.433,0.754 c-0.967,0.672-1.197,1.585-1.383,2.319c-0.118,0.467-0.221,0.87-0.501,1.213c-0.283,0.354-0.58,0.556-0.955,0.812 c-0.295,0.201-0.617,0.425-0.947,0.734C2.004,32.108,2,32.055,2,32C2,17.388,12.45,5.221,26.283,2.551 c0.111,0.172,0.225,0.339,0.334,0.49c0.348,0.48,0.434,0.633,0.411,0.915c-0.025,0.331-0.151,0.49-0.545,0.944L26.287,5.13 c-0.26,0.312-0.527,0.465-0.898,0.676c-0.328,0.188-0.701,0.4-1.111,0.754c-0.163,0.142-0.33,0.25-0.488,0.354 c-0.477,0.316-1.131,0.75-1.371,1.701c-0.244,0.983,0.319,1.662,0.656,2.068c0.108,0.132,0.291,0.352,0.287,0.411 c-0.04,0.51-0.147,0.753-0.514,1.14c-0.071,0.078-0.133,0.119-0.276,0.212c-0.113,0.072-0.232,0.15-0.364,0.251l-0.121,0.11 c-0.06,0.063-0.586,0.643-0.898,1.551c-0.237,0.715-0.247,1.088-0.044,1.598l0.044,0.118c0.036,0.121,0.07,0.547,0.072,0.822 l-0.084,1.218l0.814,0.203c0.535,0.133,0.806,0.244,1.353,0.514c0.351,0.169,0.582,0.33,0.874,0.533l0.294,0.199 c0.392,0.234,0.79,0.193,1.213,0.146c0.211,0.021,0.397,0.035,0.574,0.05c0.385,0.03,0.725,0.058,1.209,0.128l0.314,0.039 c0.244,0.03,0.438,0.051,0.708,0.123c0.154,0.043,0.285,0.143,0.502,0.313c0.37,0.292,0.877,0.691,1.705,0.691 c0.724-0.005,1.192-0.323,1.534-0.556c0.198-0.134,0.317-0.212,0.465-0.253c0.348-0.099,0.746-0.095,1.151-0.074 c0.584,0.033,1.175,0.021,1.723-0.115c0.255-0.064,0.458-0.152,0.652-0.242c0.17-0.078,0.233-0.105,0.254-0.109l0.072,0.002 L36.64,19.7c0.066,0.005,0.169,0.049,0.299,0.104c0.257,0.11,0.608,0.262,1.138,0.28c1.079,0,2.751-1.39,2.771-1.407 c0.186-0.164,0.341-0.236,0.599-0.357c0.182-0.085,0.373-0.176,0.636-0.329c0.276-0.183,0.496-0.361,0.704-0.532 c0.294-0.241,0.487-0.401,0.82-0.517c0.697-0.248,1.029-0.34,1.461-0.194c0.247,0.086,0.347,0.155,0.666,0.414 c0.156,0.126,0.239,0.246,0.379,0.445c0.136,0.195,0.28,0.397,0.475,0.605c0.087,0.097,0.159,0.188,0.227,0.275 c0.218,0.275,0.489,0.619,0.997,0.899c0.633,0.344,1.408,0.294,1.978,0.179c0.256-0.052,0.455-0.1,0.668-0.067l0.354,0.048 c0.244,0.031,0.42,0.054,0.591,0.11c0.086,0.026,0.176,0.062,0.284,0.12c0.438,0.233,0.602,0.441,0.987,1.017 c0.342,0.522,0.417,0.906,0.554,1.604l0.071,0.357c0.121,0.615,0.134,1.033,0.151,1.611l0.02,0.551 c0.011,0.265,0.032,0.497,0.054,0.716c0.043,0.438,0.071,0.728-0.028,1.138c-0.059,0.25-0.178,0.415-0.402,0.709 c-0.254,0.333-0.57,0.748-0.74,1.369l-0.05,0.17c-0.181,0.62-0.353,1.206-0.16,2.073c0.045,0.193,0.036,0.76,0.029,1.174 c-0.019,1.132-0.03,1.88,0.444,2.362c0.217,0.221,0.505,0.342,0.811,0.342l0.31-0.021l0.204-0.098 c0.285-0.136,0.532-0.331,0.754-0.547c0.008,0.018,0.015,0.035,0.022,0.053c0.275,0.614,0.863,0.967,1.615,0.967 c0.824,0,2.492-0.584,2.606-1.665c0.027-0.285,0.016-0.543,0.002-0.786c-0.021-0.351-0.014-0.419,0.053-0.526 c0.039-0.03,0.207-0.079,0.318-0.11c0.35-0.101,0.827-0.237,1.269-0.664c0.387-0.384,0.56-0.77,0.699-1.079 c0.104-0.232,0.164-0.359,0.286-0.485c0.072-0.076,0.17-0.126,0.348-0.211C61.964,30.525,62,31.258,62,32 C62,48.568,48.568,62,32,62z"
                          ></path>
                          <path
                            d="M44.629,28.162c-1.1,0.317-1.496,1.157-1.786,1.771c-0.155,0.33-0.29,0.614-0.512,0.819 c-0.392,0.366-0.771,0.568-1.211,0.802c-0.488,0.26-1.041,0.554-1.613,1.088c-0.204,0.189-0.438,0.352-0.661,0.511 c-0.737,0.523-1.852,1.314-1.525,2.804c0.214,0.935,0.933,1.493,1.922,1.493c0.655,0,1.366-0.229,2.055-0.451 c0.34-0.109,0.677-0.22,0.984-0.288c1.752-0.383,2.951-0.842,4.263-2.16c0.144-0.143,0.294-0.286,0.446-0.432 c1.134-1.08,2.846-2.713,1.573-4.603C47.708,28.231,46.191,27.713,44.629,28.162z M45.61,32.671 c-0.162,0.155-0.323,0.309-0.48,0.465c-0.983,0.988-1.806,1.299-3.277,1.621c-0.365,0.08-0.767,0.208-1.17,0.338 c-0.502,0.161-1.069,0.345-1.414,0.354c0.021-0.122,0.18-0.271,0.735-0.665c0.271-0.193,0.58-0.412,0.865-0.678 c0.382-0.355,0.756-0.555,1.19-0.786c0.493-0.263,1.053-0.56,1.632-1.102c0.504-0.464,0.757-1,0.96-1.431 c0.256-0.541,0.335-0.646,0.532-0.703C45.376,30.028,45.564,30,45.742,30c0.491,0,0.881,0.21,1.16,0.629 C47.16,31.012,46.87,31.47,45.61,32.671z"
                          ></path>
                          <path
                            d="M32.422,53.081c-0.231,0-0.465,0.036-0.707,0.11c-1.458,0.47-1.389,1.934-1.353,2.721 c0.014,0.289,0.026,0.562-0.001,0.8c-0.023,0.217-0.083,0.425-0.136,0.625c-0.178,0.672-0.446,1.686,0.437,2.556 c0.416,0.4,0.941,0.612,1.52,0.612c0.859,0,1.826-0.497,2.593-1.334c1.174-1.307,1.188-3.217,0.043-4.633 C34.284,53.859,33.531,53.081,32.422,53.081z M33.292,57.827c-0.406,0.445-0.866,0.678-1.11,0.678c-0.06,0-0.09-0.012-0.138-0.053 c-0.021-0.092,0.062-0.399,0.115-0.603c0.071-0.271,0.153-0.579,0.189-0.914c0.046-0.391,0.027-0.776,0.012-1.117 c-0.011-0.233-0.026-0.571,0.003-0.731c0.168-0.03,0.365,0.029,0.89,0.697C33.792,56.451,33.806,57.256,33.292,57.827z"
                          ></path>
                        </g>
                      </g>
                    </svg>
                    @if (countryService.getCountriesReady() | async) {
                      <select
                        id="register-user-country-dropdown"
                        class="w-full focus:outline-none"
                        formControlName="userFormCountry"
                        [ngClass]="{
                          'select-error':
                            userFormCountry?.invalid &&
                            userFormCountry?.touched,
                        }"
                      >
                        @for (
                          country of countryService.getCountryList();
                          track country.alpha_2
                        ) {
                          <option [value]="country.alpha_2">
                            {{ country.name }}
                          </option>
                        }
                      </select>
                    }
                  </label>
                </div>
                <div class="space-y-1">
                  <label
                    class="input floating-label w-full"
                    [ngClass]="{
                      'input-error':
                        userFormEmail?.invalid && userFormEmail?.touched,
                    }"
                  >
                    <span>
                      {{ t('register-user-form-email') }}
                    </span>
                    <svg
                      class="h-[1em] self-center opacity-50"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                    >
                      <g
                        stroke-linejoin="round"
                        stroke-linecap="round"
                        stroke-width="2.5"
                        fill="none"
                        stroke="currentColor"
                      >
                        <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                        <path
                          d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
                        ></path>
                      </g>
                    </svg>
                    <input
                      [attr.aria-invalid]="
                        userFormEmail?.invalid && userFormEmail?.touched
                          ? true
                          : null
                      "
                      [required]="true"
                      class="w-full placeholder:opacity-50 focus:placeholder-transparent"
                      formControlName="userFormEmail"
                      [placeholder]="t('register-user-form-email')"
                      type="email"
                    />
                  </label>
                  @if (userFormEmail?.invalid && userFormEmail?.touched) {
                    @if (userFormEmail?.errors?.['email']) {
                      <p class="label-text-alt text-error">
                        {{ t('register-user-form-error-email-format') }}
                      </p>
                    }
                  }
                </div>
                @if (enableDoubleOptIn()) {
                  <div class="space-y-1">
                    <label
                      class="input floating-label w-full"
                      [ngClass]="{
                        'input-error':
                          userFormPassword?.invalid &&
                          userFormPassword?.touched,
                      }"
                    >
                      <span>
                        {{ t('register-user-form-password') }}
                      </span>
                      <svg
                        class="h-[1em] opacity-50"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                      >
                        <g
                          stroke-linejoin="round"
                          stroke-linecap="round"
                          stroke-width="2.5"
                          fill="none"
                          stroke="currentColor"
                        >
                          <path
                            d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z"
                          ></path>
                          <circle
                            cx="16.5"
                            cy="7.5"
                            r=".5"
                            fill="currentColor"
                          ></circle>
                        </g>
                      </svg>
                      <input
                        [attr.aria-invalid]="
                          userFormPassword?.invalid && userFormPassword?.touched
                            ? true
                            : null
                        "
                        [type]="getInputType()"
                        autocomplete="on"
                        class="w-full placeholder:opacity-50 focus:placeholder-transparent"
                        formControlName="userFormPassword"
                        placeholder="{{ t('edit-user-dialog-form-password') }}"
                      />
                      <button
                        (click)="toggleShowPassword()"
                        class="btn btn-sm btn-square btn-ghost transition-none hover:border-0 hover:bg-transparent focus:outline-none"
                        type="button"
                        [disabled]="userFormPassword?.value?.length === 0"
                      >
                        <svg
                          class="h-6 w-6"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="1.5"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          @if (showPassword()) {
                            <path
                              d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          } @else {
                            <path
                              d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          }
                        </svg>
                      </button>
                    </label>
                    @if (
                      userFormPassword?.invalid && userFormPassword?.touched
                    ) {
                      @if (userFormPassword?.errors?.['pattern']) {
                        <p class="label-text-alt text-error">
                          {{ t('register-user-form-error-password-pattern') }}
                        </p>
                      }
                    }
                  </div>
                  <div class="space-y-1">
                    <label
                      class="input floating-label w-full"
                      [ngClass]="{
                        'input-error':
                          userFormConfirmPassword?.invalid &&
                          userFormConfirmPassword?.touched,
                      }"
                    >
                      <span>
                        {{ t('register-user-form-confirm-password') }}
                      </span>
                      <svg
                        class="h-[1em] opacity-50"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                      >
                        <g
                          stroke-linejoin="round"
                          stroke-linecap="round"
                          stroke-width="2.5"
                          fill="none"
                          stroke="currentColor"
                        >
                          <path
                            d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z"
                          ></path>
                          <circle
                            cx="16.5"
                            cy="7.5"
                            r=".5"
                            fill="currentColor"
                          ></circle>
                        </g>
                      </svg>
                      <input
                        [attr.aria-invalid]="
                          userFormConfirmPassword?.invalid &&
                          userFormConfirmPassword?.touched
                            ? true
                            : null
                        "
                        [type]="getInputType()"
                        autocomplete="on"
                        class="w-full placeholder:opacity-50 focus:placeholder-transparent"
                        formControlName="userFormConfirmPassword"
                        placeholder="{{
                          t('register-user-form-confirm-password')
                        }}"
                      />
                    </label>
                    @if (
                      userFormConfirmPassword?.invalid &&
                      userFormConfirmPassword?.touched
                    ) {
                      @if (userFormConfirmPassword?.errors?.['pattern']) {
                        <p class="label-text-alt text-error">
                          {{
                            t(
                              'register-user-form-error-confirm-password-pattern'
                            )
                          }}
                        </p>
                      }
                      @if (
                        userFormConfirmPassword?.errors?.['passwordsMismatch']
                      ) {
                        <p class="label-text-alt text-error">
                          {{
                            t(
                              'register-user-form-error-confirm-password-mismatch'
                            )
                          }}
                        </p>
                      }
                    }
                  </div>
                }
                <label class="flex w-full pt-5">
                  <input
                    [attr.aria-invalid]="
                      userForm.controls['userFormConfirmPrivacyPolicy']
                        .invalid &&
                      userForm.controls['userFormConfirmPrivacyPolicy'].touched
                        ? true
                        : null
                    "
                    class="toggle toggle-primary mr-5"
                    type="checkbox"
                    formControlName="userFormConfirmPrivacyPolicy"
                    [ngClass]="{
                      'input-error':
                        userForm.controls['userFormConfirmPrivacyPolicy']
                          .invalid &&
                        userForm.controls['userFormConfirmPrivacyPolicy']
                          .touched,
                    }"
                  />
                  <small
                    [innerHTML]="t('register-user-form-confirm-privacy-policy')"
                  ></small>
                </label>
                <button
                  (click)="createProfile()"
                  [class.btn-pulse]="submitted()"
                  [disabled]="submitted() || userForm.invalid"
                  class="btn btn-primary mt-4 w-full"
                >
                  {{ t('register-user-form-register-button') }}
                </button>
                @if ((emailTakenError$$ | async) || (genericError$$ | async)) {
                  <div
                    class="alert alert-error mt-4 flex items-center justify-center text-center"
                    [ngClass]="{ hidden: !showAlert() }"
                    role="alert"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-6 w-6 shrink-0 stroke-current"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    @if (emailTakenError$$ | async) {
                      <span class="mx-auto">
                        {{ t('register-user-form-error-email-taken') }}
                      </span>
                    }
                    @if (genericError$$ | async) {
                      <span class="mx-auto">
                        {{
                          t('register-user-form-error-generic-error-message')
                        }}
                      </span>
                    }
                  </div>
                }
              </fieldset>
            </form>
          } @else {
            <div class="text-center">
              <p class="py-6">
                {{ t('register-user-form-submitted-success') }}
              </p>
              <button class="btn btn-primary w-full" (click)="goHome()">
                {{ t('register-user-form-home-button') }}
              </button>
            </div>
          }
        }
      </div>
    </div>
  </div>
</ng-container>
